import React from "react";
import { Row, Col, Button, Modal as BootstrapModal } from "react-bootstrap";
import BigCalendar from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import moment from "moment";
import { CustomToolbar } from "./CustomToolbar";

// Initialize localization strategy
BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showEventDetails: false,
      selectedEvent: false,
    };
    this.onSelectEvent = this.onSelectEvent.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal() {
    this.setState({ showEventDetails: false });
  }

  onSelectEvent(event) {
    this.setState({ selectedEvent: event, showEventDetails: true });
  }

  render() {
    const engineer = this.state.showEventDetails
      ? this.state.selectedEvent.engineer
      : undefined;
    const engineerInfo = this.state.showEventDetails
      ? engineer.firstName + " " + engineer.lastName
      : undefined;
    return (
      <div id="region-schedule">
        <Row className={"region-schedule-container"}>
          <Col md={12}>
            <BigCalendar
              // Only show the month view
              views={["month"]}
              defaultView="month"
              // Setting the title of each event from the schedule
              // as the name of the engineer assigned to that event.
              events={this.props.shiftsDefinitions}
              onSelectEvent={this.onSelectEvent}
              // And some workarounds because *everything* is broken (TM)
              // If a specific height is not provided
              // Then the month view will not be visible
              // https://github.com/intljusticemission/react-big-calendar/issues/175
              style={{ height: "700px" }}
              // If you don't set the default date, the next/back buttons won't work
              // https://github.com/intljusticemission/react-big-calendar/issues/718
              defaultDate={new Date()}
              components={{
                toolbar: CustomToolbar,
              }}
              titleAccessor={({ start, engineer }) =>
                `${moment(start).format("HH:mm")} ${engineer.firstName} ${
                  engineer.lastName
                }`
              }
              tooltipAccessor={shift => {
                const format = "YYYY-MM-DD hh:mm A";
                const start = moment(shift.start).format(format);
                const end = moment(shift.end).format(format);
                return `${shift.engineer.firstName} ${
                  shift.engineer.lastName
                }${"\n"}${start}${"\n"}${end}`;
              }}
            />
            <div className={"text-center center-back-button"}>
              <br />
              <a
                id="back-to-regions"
                className={"btn btn-primary"}
                onClick={this.props.onRegionList}
              >
                Back to regions
              </a>
              <br />
            </div>
          </Col>
        </Row>

        <BootstrapModal
          id="calendar-modal"
          show={this.state.showEventDetails}
          onHide={this.handleCloseModal}
        >
          <BootstrapModal.Header closeButton>
            <BootstrapModal.Title>
              ENGINEER: <strong>{engineerInfo}</strong>
            </BootstrapModal.Title>
          </BootstrapModal.Header>
          <BootstrapModal.Body>
            <div>
              FROM:{" "}
              {moment(this.state.selectedEvent.start).format(
                "YYYY-MM-DD hh:mm A",
              )}
            </div>
            <div>
              TO:{" "}
              {moment(this.state.selectedEvent.end).format(
                "YYYY-MM-DD hh:mm A",
              )}
            </div>
          </BootstrapModal.Body>
          <BootstrapModal.Footer>
            <Button
              className="btn btn-primary "
              id="close"
              onClick={this.handleCloseModal}
            >
              Close
            </Button>
          </BootstrapModal.Footer>
        </BootstrapModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/calendar/ReadOnlyCalendar.js